var render = function render(){
  var _vm$profile$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "account-info-ctn"
  }, [_c('h2', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('profile.menu.account_information')))]), _c('v-container', {
    staticClass: "mt-6 ma-0"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.validForm,
      callback: function ($$v) {
        _vm.validForm = $$v;
      },
      expression: "validForm"
    }
  }, [_c('v-row', {
    staticClass: "gutter-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('small', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('profile.company_name')))]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s((_vm$profile$company = _vm.profile.company) === null || _vm$profile$company === void 0 ? void 0 : _vm$profile$company.name))])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('small', {
    staticClass: "text-capitalize field-label"
  }, [_vm._v(_vm._s(_vm.$t('profile.email')))]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.profile.email))])])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "rules": [_vm.formRules.required, _vm.formRules.noMarkup, _vm.formRules.maxLength(150)],
      "counter": 150,
      "maxlength": "150",
      "label": `${_vm.$t('profile.first_name')}*`,
      "required": ""
    },
    model: {
      value: _vm.firstname,
      callback: function ($$v) {
        _vm.firstname = $$v;
      },
      expression: "firstname"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "rules": [_vm.formRules.required, _vm.formRules.noMarkup, _vm.formRules.maxLength(150)],
      "counter": 150,
      "maxlength": "150",
      "label": `${_vm.$t('profile.last_name')}*`,
      "required": ""
    },
    model: {
      value: _vm.lastname,
      callback: function ($$v) {
        _vm.lastname = $$v;
      },
      expression: "lastname"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "rules": [_vm.formRules.required, _vm.formRules.websiteRule, _vm.formRules.maxLength(2000)],
      "counter": 2000,
      "maxlength": "2000",
      "label": `${_vm.$t('profile.company_website')}*`,
      "required": ""
    },
    on: {
      "blur": _vm.onBlurUrl,
      "focus": _vm.onFocusUrl
    },
    model: {
      value: _vm.website,
      callback: function ($$v) {
        _vm.website = $$v;
      },
      expression: "website"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "outlined": "",
      "items": _vm.countryList,
      "label": _vm.$t('profile.country'),
      "search-input": _vm.originSearchInput,
      "item-text": "description",
      "item-value": "key"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.originSearchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.originSearchInput = $event;
      },
      "change": function ($event) {
        _vm.originSearchInput = '';
      }
    },
    model: {
      value: _vm.selectedCountry,
      callback: function ($$v) {
        _vm.selectedCountry = $$v;
      },
      expression: "selectedCountry"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('ChangePasswordModal')], 1), _c('v-col', {
    staticClass: "text-end",
    attrs: {
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "px-11",
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.validForm,
      "color": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.update')) + " ")])], 1)], 1), _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-col', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "header-text mb-4"
  }, [_vm._v(_vm._s(_vm.$t('profile.connected_account')))])]), _c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.isGoogleLinked ? _c('div', {
    key: "google-linked",
    staticClass: "d-flex align-center flex-wrap connected-status"
  }, [_c('google-icon', {
    staticClass: "mr-3"
  }), _c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$t('profile.google_connected')))]), _c('v-btn', {
    staticClass: "google-unlink-btn ml-md-4",
    attrs: {
      "text": "",
      "color": "error",
      "loading": _vm.unlinkingGoogle
    },
    on: {
      "click": function ($event) {
        _vm.showUnlinkDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.google_unlink')) + " ")])], 1) : _c('div', {
    key: "google-unlinked",
    staticClass: "google-signin-ctn"
  }, [_c('div', {
    staticClass: "google-btn-shell",
    class: {
      'google-btn-shell-disabled': _vm.linkingGoogle
    }
  }, [_c('button', {
    staticClass: "google-sso-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.linkingGoogle
    },
    on: {
      "click": _vm.onGoogleShellClick
    }
  }, [_c('google-icon', {
    staticClass: "google-sso-icon"
  }), _c('span', {
    staticClass: "google-sso-label"
  }, [_vm._v(_vm._s(_vm.$t('profile.log_in_with_google')))])], 1), _c('div', {
    ref: "googleBtn",
    staticClass: "google-sdk-overlay",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])], 1), _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h2', {
    staticClass: "title text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('profile.system_settings')))]), _c('LanguageSelect')], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "550",
      "persistent": ""
    },
    model: {
      value: _vm.showUnlinkDialog,
      callback: function ($$v) {
        _vm.showUnlinkDialog = $$v;
      },
      expression: "showUnlinkDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('profile.google_unlink_confirm_title')))]), _c('v-card-text', {
    staticClass: "py-5 px-5 black--text"
  }, [_vm._v(_vm._s(_vm.$t('profile.google_unlink_confirm_message')))]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.unlinkingGoogle
    },
    on: {
      "click": function ($event) {
        _vm.showUnlinkDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.unlinkingGoogle
    },
    on: {
      "click": _vm.unlinkGoogle
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.google_unlink')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }